<template src="./ViewTask.html"></template>

<script>
import {createNamespacedHelpers} from 'vuex';
import Pagination from "@/components/components/pagination";
import TopMenu from "@/components/suppliers/components/topMenu"

const {mapGetters, mapActions} = createNamespacedHelpers('suppliers/viewTask');

export default {
  name: "SuppliersTask",
  components: {
    Pagination,
    TopMenu,
  },
  data() {
    return {
      showOverlay: 0,
      taskId: this.$route.params.id,
      fieldsList: [
        {
          key: 'id',
          label: 'Номер записи',
        },
        {
          key: 'position',
          label: 'Позиция',
        },
        {
          key: 'address',
          label: 'Сайт',
        },
        {
          key: 'keyQuantity',
          label: 'Число ключей на главной',
        },
        {
          key: 'minusPhrases',
          label: 'Число минус фраз',
        },
        {
          key: 'requests',
          label: 'Запросы по которым найден сайт',
        },
        {
          key: 'region',
          label: 'Регион поиска',
        },
        {
          key: 'excludedAction',
          label: '',
        },
      ]
    }
  },
  methods: {
    ...mapActions(['GET_INFO', 'EXCLUDE']),
    goToPage(page) {
      this.$store.commit('suppliers/viewTask/CURRENT_PAGE', page)
      this.getData()
    },
    perPage(page) {
      this.$store.commit('suppliers/viewTask/PER_PAGE', page)
      this.$store.commit('suppliers/viewTask/CURRENT_PAGE', 1)
      this.getData()
    },
    selfInitPageSize() {
      let winHeight = this.initPageSize(305)
      this.$store.commit('suppliers/viewTask/PER_PAGE', winHeight)
      this.$store.commit('suppliers/viewTask/CURRENT_PAGE', 1)
    },
    exclude(foundId) {
      this.EXCLUDE({th: this, foundId: foundId})
    },
    getData() {
      this.GET_INFO({th: this, id: this.taskId})
    }
  },
  computed: {
    ...mapGetters([
      'TASKS_INFO',
      'CURRENT_PAGE',
      'TOTAL_ROWS',
      'PER_PAGE',
      'AMOUNT_PAGE',
    ]),
  },
  mounted() {
    this.selfInitPageSize()
    this.getData()
  },
  created() {
    if (this.$store.getters.getAllowSection.indexOf('suppliers') === -1) {
      this.$router.push({name: 'permissionDenied'})
      return
    }
  },
}
</script>

<style scoped>

.input-add-use {
  text-align: left;
}

.submit-button {
  text-align: right;
}

</style>